/**
 * Created by sy on 2018/9/10.
 */
import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

import article from "./modules/article.js";

import audio from "./modules/audio.js";
import learning_camp_detail from "./modules/learning_camp_detail.js";
import online_course from "./modules/online_course.js";
import column_video from "./modules/column_video.js";
import working_wall from "./modules/working_wall";
import collect from "./modules/collect";
import preview_column from "./modules/preview_column";
import knowledge_exchange from "./modules/knowledge_exchange";
import course from "./modules/course";
import daka from "./modules/daka";
import living from "./modules/living";
import message from "./modules/message";
import yearCourse from "./modules/365course.js";
import p2pstudy from "./modules/p2pstudy";
import examAudio from "./modules/examAudio"; // 小测验音频
Vue.use(Vuex);

const debug = process.env.VUE_APP_MODE !== "prod";
const state = {
  // message: "uuuuuuuu",
  getBannerList: {
    // list:'1ffff'
  },
  searchWord: "",
  searchNav: 0,
};

const store = new Vuex.Store({
  modules: {
    article,
    audio,
    learning_camp_detail,
    column_video,
    working_wall,
    collect,
    preview_column,
    online_course,
    knowledge_exchange,
    course,
    daka,
    living,
    message,
    yearCourse,
    p2pstudy,
    examAudio,
  },
  state,
  getters,
  mutations,
  actions,
  strict: debug,
});
export default store;
